// extracted by mini-css-extract-plugin
export var required = "_h1-0";